import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { FriendlyDateTime } from '../Date/friendly-date-time'
import { Toast } from '../NarusMaterial'

interface SymptomToastProps {
  id: string
  close: (id: string) => void
  clientName: string
  patientId: string
  patientName: string
  symptomName: string
  newSymptomCategory: string
  prevSymptomCategory: string
  createdAt: string
}

export function SymptomToast ({ id, close, clientName, patientId, patientName, newSymptomCategory, prevSymptomCategory, symptomName, createdAt }: SymptomToastProps): JSX.Element {
  const navigate = useNavigate()

  const handleClose = useCallback((): void => {
    close(id)
  }, [ close, id ])

  function handleCardClick (): void {
    navigate(`/patient/${clientName}/${patientId}/patientFolder`)
  }

  return (
    <Toast
      onDelete={handleClose}
    >
      <Content
        onClick={handleCardClick}
        patientName={patientName}
        createdAt={createdAt}
        newSymptomCategory={newSymptomCategory}
        prevSymptomCategory={prevSymptomCategory}
        symptomName={symptomName}
      />
    </Toast>
  )
}

interface ContentProps {
  prevSymptomCategory: string
  newSymptomCategory: string
  patientName: string
  symptomName: string
  createdAt: string
  onClick: () => void
}

function Content ({ prevSymptomCategory, newSymptomCategory, patientName, symptomName, createdAt, onClick }: ContentProps): JSX.Element {
  let categories
  if (prevSymptomCategory === 'N/A') {
    categories = `New ${newSymptomCategory}`
  } else {
    categories = `${prevSymptomCategory} → ${newSymptomCategory}`
  }

  return (
    <button
      className='cursor-pointer'
      onClick={onClick}
    >
      <h2>Symptoms</h2>
      <p>{patientName} reported {symptomName} {categories}</p>
      <p className='time'>
        <FriendlyDateTime datetime={createdAt} />
      </p>
    </button>
  )
}
